const APNS_TOKEN_KEY = 'apns-token-cache';

export const getCachedApnsToken = (uid: string): string | null => {
  const cacheStr = window.localStorage.getItem(APNS_TOKEN_KEY);
  try {
    const cache = cacheStr ? JSON.parse(cacheStr) ?? {} : {};
    return cache[uid] ?? null;
  } catch {
    return null;
  }
};

export const setCachedApnsToken = (uid: string, apnsToken: string) => {
  window.localStorage.setItem(
    APNS_TOKEN_KEY,
    JSON.stringify({ [uid]: apnsToken }),
  );
};
